import "aos/dist/aos.css";
import React from "react";
import Dropzone from "react-dropzone";
import UploadFilesList from "./upload-files-list";
import Section from "../section";
import {AttachmentTypes} from "../../utils/constants";
import HelperService from "../../services/helper-service";

export default function Fileupload({
                                      files,
                                      filesData,
                                      onChange,
                                      className='',
                                      attachmentTypes=[],
                                      attachmentCategories=[],
                                      cardClass='col-12',
                                      ...props
}){
  const setFiles = (newFiles=null, newFilesData=null) => {
    if (props.setFieldValue && 'function'===typeof props.setFieldValue){ //formik setter
      props.setFieldValue("files", newFiles);
      props.setFieldValue("filesData", newFilesData);
    }
    if (onChange && 'function' === typeof onChange){
      onChange({files:newFiles, filesData:newFilesData});
    }
  };

  const onAcceptedFiles = (acceptedFiles) => {
    let newAcceptedFiles = [];
    let newFilesData = [];
    if (acceptedFiles && acceptedFiles.length){
      newAcceptedFiles = acceptedFiles.map((f)=>{
          const isImage = !!(f.type && f.type.includes('image/'));
          let type = null;
          let attachmentTypeIds = attachmentTypes.map((t)=>t.val);
          if (attachmentTypeIds.includes(AttachmentTypes.gallery.val) && attachmentTypeIds.includes(AttachmentTypes.document.val)){
            type = !isImage ? AttachmentTypes.document.val : AttachmentTypes.gallery.val;
          }
          if (!type && attachmentTypeIds.length>0){
            type = attachmentTypeIds[0];
          }
          const fd = {
            title: f.path,
            description: "",
            attachment_type_id: type,
            attachment_category_id: attachmentCategories?.length>0 ? attachmentCategories[0].id : '',
            is_image: isImage,
            thumb: isImage ? URL.createObjectURL(f) : null,
          };
          newFilesData.push(fd);
          f.fileData = fd;
          return f;
        })
    }
    setFiles(newAcceptedFiles, newFilesData);
  }

  return (
    <>
      <Dropzone onDrop={acceptedFiles => onAcceptedFiles(acceptedFiles)}>
        {({getRootProps, getInputProps}) => (
          <Section className={`dropzone ${className}`}>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {!files || !files.length && <p className={'clickable p-3 m-0'}>Pretiahnite súbory sem, alebo kliknite pre výber...</p>}
            </div>
            <UploadFilesList files={files}
                             cardClass={cardClass}
                             filesData={filesData}
                             attachmentTypes={attachmentTypes}
                             attachmentCategories={attachmentCategories}
                             onChange={({files, filesData})=>{setFiles(files, filesData);}} />
          </Section>
        )}
      </Dropzone>
    </>
  );
}
